import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact-container page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("h1", { class: "contact-title" }, "Contact Info", -1),
    _createElementVNode("p", { class: "contact-text" }, " If you have any question, please email general@henium.com ", -1)
  ])))
}